// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"3304bad4","421":"60fe2078","489":"e7481917"}[chunkId] + ".chunk.js";
};